module.exports = __webpack_public_path__ + "img/incident-detail-hide-section.8a997ec1.svg";